import { SUPPORT_MODAL_TYPES, } from './models';
export var useContactSupportModalSchema = function (supportType, config) {
    switch (supportType) {
        case SUPPORT_MODAL_TYPES.DEV_PLAN:
            return {
                title: 'Oops, something went wrong',
                description: 'Looks like there’s a problem with your Developer Plan. Sorry about that. Contact us at <a href="mailto:support@appspotr.com?subject=' +
                    "".concat((config === null || config === void 0 ? void 0 : config.orgId)
                        ? 'Developer Plan Issue in ' + config.orgId
                        : 'Developer Plan Issue') +
                    '">support@appspotr.com</a> and we’ll solve it.',
                primaryButtonText: 'Contact Support',
                secondaryButtonText: 'Ignore For Now',
            };
        default:
            return {
                title: '',
                description: '',
                primaryButtonText: '',
            };
    }
};
